import useContentGrid from '@components/PublicationBookingPlanner/hooks/useContentGrid'

import type {
  UsePublicationBookingPlannerPayload,
} from '@components/PublicationBookingPlanner/hooks/usePublicationBookingPlanner'

import BookingItem from './BookingItem'
import GridCells from './GridCells'

import styles from './styles.module.scss'

interface ContentGridProps {
  bookingPlannerPayload: UsePublicationBookingPlannerPayload,
}

const ContentGrid = (props: ContentGridProps) => {
  const {
    bookingPlannerPayload: {
      editionData: {
        isPending,
      },
      publicationBookingPayload: {
        layoutTemplate,
        publicationBooking,
      },
      publicationBookingItemsPayload: {
        filteredPublicationBookingItems,
      },
      selectedBookingData: {
        approvedArtworkIds = [],
        isReleased,
      },
      zoom,
    },
  } = props

  const contentGridPayload = useContentGrid({
    layoutTemplate,
    publicationBooking,
    publicationBookingItems: filteredPublicationBookingItems,
    styles: {
      draggingOver: styles.draggingOver,
      dropValid: styles.dropValid,
      hidden: styles.hidden,
    },
    zoom,
  })

  const {
    cellSize,
    contentGrid: {
      columns, rows, width, height, y, x,
    },
    dropPosition,
    dropTargetRef,
  } = contentGridPayload

  return (
    <div
      className={styles.root}
      ref={dropTargetRef}
      style={{
        height,
        left: x,
        top: y,
        width,
      }}
    >
      <GridCells
        cellSize={cellSize}
        columns={columns}
        // @ts-expect-error TS2322
        dropPosition={dropPosition}
        rows={rows}
      />

      {filteredPublicationBookingItems.map(publicationBookingItem => (
        <BookingItem
          approvedArtworkIds={approvedArtworkIds}
          cellSize={cellSize}
          isPending={isPending}
          isReleased={isReleased}
          key={publicationBookingItem.id}
          publicationBookingItem={publicationBookingItem}
          zoom={zoom}
        />
      ))}
    </div>
  )
}

export default ContentGrid
